import React from 'react';
import OutageSetup from '../Outage-Setup/OutageSetup';
// import { useEntitlements } from '../../DataContext/EntitlementsContext';

const OutageManagementTab: React.FC = () => {
  // const { entitlements } = useEntitlements();


  // const hasAccess = (path: string) => {
  //   return entitlements.some(
  //     (entitlement) =>
  //       entitlement.po_path.toLowerCase() === path.toLowerCase() &&
  //       ['read', 'write'].includes(entitlement.privilege.toLowerCase())
  //   );
  // };
  

  // Path for Outage Setup to check access
  // const outageSetupPath = '/outage-management';






  return (
    // flex-1/min-h-0 all the way down so the card inherits the viewport height
    // the page shell reserved for it, and OutageSetup can size itself to what
    // is actually left rather than assuming a full 100vh.
    <div className="mx-10 mt-10 short:mt-4 mb-4 short:mb-2 font-poppins flex flex-1 min-h-0 flex-col">
      <div className="flex justify-between items-center mx-2 mb-4 short:mb-2 shrink-0">
        <h1 className="text-2xl short:text-xl font-bold text-gray-700">Outage Management</h1>
      </div>

      <div className="bg-white shadow-lg p-6 short:p-3 rounded-lg flex flex-1 min-h-0 flex-col">
      <OutageSetup/>
        {/* {hasAccess(outageSetupPath) ? (
          <OutageSetup />
        ) : (
          <div className="text-red-500 font-medium">You do not have access to Outage Management.</div>
        )} */}
     
      </div>
    </div>
  );
};

export default OutageManagementTab;
